module.exports = __webpack_public_path__ + "8ceafa76ec73a8629ebc2c404986767f.png";